<script lang="ts">
    import ReviewEntity from "@apps/reviews/entities/ReviewEntity";
    import { ReviewTranslationResponseEntity } from "@apps/reviews/entities/ReviewTranslationEntity";
    import VotesQuery from "@apps/reviews/queries/VotesQuery";
    import VotesService from "@apps/reviews/services/VotesService";
    import { I18nModule } from "@modules/i18n/I18nModule";
    import { lastValueFrom } from "rxjs";
    import { createEventDispatcher } from "svelte";
    import { container } from "tsyringe";

    export let review: ReviewEntity;
    export let reviewsTranslation: ReviewTranslationResponseEntity | null;
    export let translationsPendingIds: number[];
    export let namespace: string;

    const i18nModule = container.resolve(I18nModule);
    let showTranslation = false;

    const votesQuery = container.resolve(VotesQuery);
    const votesService = container.resolve(VotesService);

    const dispatch = createEventDispatcher();

    const reviewVotes$ = votesQuery.selectByReviewId(review.id);

    const t_anonym$ = i18nModule.exports.i18n.selectT(namespace, "anonym");
    $: customerName = review.customer?.name ?? $t_anonym$;

    const handleOpenReview = (event: CustomEvent<{ idx: number }>) => {
        dispatch("openReview", {
            reviewId: review.id,
            activeImageIndex: event.detail?.idx,
        });
    };

    const handleSeeTranslation = (
        event: CustomEvent<{ reviewId: number; targetLanguage: string }>
    ) => {
        showTranslation = !showTranslation;

        if (showTranslation) {
            dispatch("seeTranslation", {
                reviewId: event.detail.reviewId,
                targetLanguage: event.detail.targetLanguage,
            });
        }
    };

    const handleToggleVote = (event: CustomEvent<{ reviewId: number }>) => {
        lastValueFrom(votesService.toggleVote(event.detail.reviewId));
    };

    $: isTranslationLoading = translationsPendingIds.includes(review.id);

    $: isTranslated = showTranslation && !isTranslationLoading;

    $: getContent = () => {
        if (isTranslated && reviewsTranslation) {
            return {
                title: reviewsTranslation.title,
                body: reviewsTranslation.body,
                reply: reviewsTranslation.reply,
            };
        }
        return {
            title: review.title,
            body: review.body,
            reply: review.reply?.body || null,
        };
    };
    $: translsatedContent = getContent();

    $: props = {
        review,
        customerName,
        translsatedContent,
        isTranslationLoading,
        showTranslation,
        reviewVotes: $reviewVotes$,
        handleOpenReview,
        handleSeeTranslation,
        handleToggleVote,
    };
</script>

<slot {props} />
